export const QUICK_SEARCH_LIMIT = 5;
export const CATEGORY_SEARCH_LIMIT = 50;
